var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 35,
    viewBox: "0 0 28 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9997 0.400635C6.82468 0.400635 0.333008 5.90147 0.333008 14.409C0.333008 19.8415 4.51842 26.2306 12.8722 33.5936C13.5213 34.1573 14.4951 34.1573 15.1443 33.5936C23.4809 26.2306 27.6663 19.8415 27.6663 14.409C27.6663 5.90147 21.1747 0.400635 13.9997 0.400635ZM13.9997 17.484C12.1205 17.484 10.583 15.9465 10.583 14.0673C10.583 12.1881 12.1205 10.6506 13.9997 10.6506C15.8788 10.6506 17.4163 12.1881 17.4163 14.0673C17.4163 15.9465 15.8788 17.484 13.9997 17.484Z",
    fill: "#9069FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/Marker.8b9f4d03af65fb5b82957cc323e20468.svg";
export { ForwardRef as ReactComponent };